import { render, staticRenderFns } from "./UserEditDialog.vue?vue&type=template&id=389753a8&scoped=true"
import script from "./UserEditDialog.vue?vue&type=script&lang=ts"
export * from "./UserEditDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389753a8",
  null
  
)

export default component.exports